import { createRouter as createTanStackRouter } from '@tanstack/react-router'
import { QueryClient } from '@tanstack/react-query';
import { queryClient } from './providers/QueryProvider';

// Import the generated route tree
// This will be generated by the TanStack Router plugin
import { routeTree } from './routeTree.gen'

export function createRouter() {
  const router = createTanStackRouter({
    routeTree,
    defaultPreload: 'intent',
    // Enable scroll restoration for better UX
    scrollRestoration: true,
    // Configure search params for filtering/pagination
    defaultPreloadStaleTime: 0,
    context: {
      queryClient,
    },
  })

  return router
}

// Register router type for TypeScript
declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createRouter>
  }
}